export const ptBRAgenda = {
  title: 'Agenda',
  newEvent: 'Novo evento',
  refresh: 'Atualizar',
  agendaUpdated: 'Agenda atualizada',
  loading: 'Carregando agenda…',
  loadError: 'Falha ao carregar eventos',
  notConnected: 'Google não está conectado',
  notConnectedHint: 'Conecte uma conta Google nas Configurações para usar a agenda compartilhada.',
  notSelected: 'Nenhum calendário selecionado',
  notSelectedHint: 'Um gerente da casa pode escolher o calendário da família nas Configurações.',
  goToSettings: 'Abrir Configurações',
  noEvents: 'Nenhum evento próximo',
  noEventsHint: 'Adicione seu primeiro evento para compartilhar com a casa.',
  createDialogTitle: 'Novo evento',
  titleLabel: 'Título',
  titlePlaceholder: 'ex.: Consulta no dentista',
  allDayLabel: 'Dia inteiro',
  startLabel: 'Início',
  endLabel: 'Fim',
  startDateLabel: 'Data de início',
  endDateLabel: 'Data de fim',
  locationLabel: 'Local',
  locationPlaceholder: 'Opcional',
  notesLabel: 'Notas',
  notesPlaceholder: 'Opcional',
  create: 'Criar',
  cancel: 'Cancelar',
  validationTitleRequired: 'O título é obrigatório',
  validationStartRequired: 'O início é obrigatório',
  validationEndRequired: 'O fim é obrigatório',
  validationEndAfterStart: 'O fim deve ser depois do início',
  deleteTitle: 'Excluir evento?',
  deleteDescription: 'Isso remove "{{title}}" da agenda compartilhada. Não é possível desfazer.',
  delete: 'Excluir',
  deleteAction: 'Excluir evento',
  // detail panel
  close: 'Fechar',
  whenLabel: 'Quando',
  descriptionLabel: 'Descrição',
  openInMaps: 'Abrir "{{location}}" no Google Maps',
  toastCreated: 'Evento criado',
  toastCreatedError: 'Falha ao criar evento',
  toastDeleted: 'Evento excluído',
  toastDeletedError: 'Falha ao excluir evento',
  allDayBadge: 'Dia inteiro',
  // redesign: coming-up + by-week feed
  comingUp: 'Em breve',
  todaySection: 'Hoje',
  weekThis: 'Esta semana',
  weekNext: 'Próxima semana',
  weekOf: 'Semana de {{date}}',
  routineSummary: 'Rotina · {{n}}',
  routineToggle: 'Alternar eventos de rotina',
  countToday: 'Hoje',
  countTomorrow: 'Amanhã',
  countDays: 'em {{n}} dias',
  emptyWeek: 'Nada agendado',
} as const;
